// BUG meter._difference should be meter.difference

angular.module('directives.calculator')
    .directive('calculator', [
        'configs',
        '$translate',
        function (configs, $translate) {

            var BigNumber = require('bignumber.js');
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    meter: '=',
                    calc: '&',
                    calctariffs: '&'
                },
                template: require('../templates/calculator.html'),
                controller: [
                    '$scope',
                    '$timeout',
                    function ($scope, $timeout) {

                        var uaMonth = ["січень", "лютий", "березень", "квітень", "травень", "червень", "липень", "серпень", "вересень", "жовтень", "листопад", "грудень"];
                        var ruMonth = ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"];
                        var config = configs.payments_config;
                        var tariff = config.energyCalc.tariffs;

                        var Calculator = {
                            months : [],
                            list: {
                                heating: '1',
                                hostel: '0',
                                house: '1',
                                large_families: '0',
                                location: '1',
                                stove: '0',
                                total: '0',
                                privileges: [{
                                    Units: $scope.meter.Privileges ? $scope.meter.Privileges.Units : '',
                                    Percent: $scope.meter.Privileges ? $scope.meter.Privileges.Percent + '%' : ''
                                }]
                            },
                            getMonthLocalization: function () {
                               var lang = $translate.use();
                                Calculator.months = lang === 'ua' ? uaMonth : ruMonth;
                            },
                            clearData: function (meter) {
                                meter.enableTariff = false;
                                meter.calcTariff = '';
                                meter.calcDifference = '';
                                meter.calcAmount = '';
                                meter.calcAmountDiscount = '';

                                Calculator.calcTariff(meter);
                            },
                            getMonthsName: function () {
                                var regional = 'UA';
                                Calculator.months = ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"];

                            },
                            getThisMonth: function () {
                            Calculator.getMonthLocalization();
                                var today = new Date().getMonth();
                                return Calculator.months[today];
                            },

                            getPrevMonth: function () {
                                var date = new Date();
                                var month = date.getMonth() - 1;
                                return (month > 0 ? month : 11);
                            },
                            calcTariff: function (meter) {
                                if (Calculator.months.indexOf(Calculator.list.selectedMonth) > 0) {
                                  Calculator.list.month = Calculator.months.indexOf(Calculator.list.selectedMonth);
                                } else {
                                  Calculator.list.month = new Date().getMonth();
                                }
                                Calculator.list.month = Calculator.months.indexOf(Calculator.list.selectedMonth);

                                if (!meter._difference) {
                                    return;
                                }

                                var selectedTariff;
                                var tariffAmount = 0;

                                //1.5. Населенню, яке розраховується з енергопостачальною організацією за загальним розрахунковим засобом
                                //обліку та об’єднане шляхом створення юридичної особи, житлово-експлуатаційним організаціям, крім гуртожитків
                                if (Calculator.list.total == '1') {
                                  Calculator.list.hostel = '0';
                                  Calculator.list.large_families = '0';
                                  selectedTariff = tariff[2];


                                //1.4. Для багатодітних, прийомних сімей та дитячих будинків сімейного типу незалежно від обсягів споживання електроенергії
                                } else if (Calculator.list.large_families == '1') {
                                      selectedTariff = tariff[3]

                                //1.6. Гуртожиткам (які підпадають під визначення «населення, яке розраховується з енергопостачальною
                                // організацією за загальним розрахунковим засобом обліку»)
                                } else if (Calculator.list.hostel == '1' && Calculator.list.heating != '0') {
                                    selectedTariff = tariff[3];

                                //1.2. Населенню, яке проживає в житлових будинках (у тому числі в житлових будинках готельного типу, квартирах та гуртожитках),
                                //обладнаних у встановленому порядку електроопалювальними установками (у тому числі в сільській місцевості):
                                  //1.2.1. У період з 01 квітня по 30 вересня (включно):
                                } else if (Calculator.list.heating == '0') {
                                    if (Calculator.list.month > 3 || Calculator.list.month < 9) {
                                        selectedTariff = tariff[0];
                                    }

                                  //1.2.2. У період з 01 жовтня 2017 року по 30 квітня (включно)
                                    if (Calculator.list.month > 8 || Calculator.list.month < 4) {
                                        selectedTariff = tariff[1];
                                    }

                                //1.3. Населенню, яке проживає в багатоквартирних будинках, не газифікованих природним газом і в
                                //яких відсутні або не функціонують системи централізованого теплопостачання (у тому числі в сільській місцевості):
                                } else if (Calculator.list.heating == 'none') {

                                //1.3.1. У період з 01 квітня по 30 вересня (включно):
                                        if (Calculator.list.month > 3 || Calculator.list.month < 9) {
                                            selectedTariff = tariff[0];
                                        }

                                //1.3.2. У період з 01 жовтня 2017 року по 30 квітня (включно):
                                        if (Calculator.list.month > 8 || Calculator.list.month < 4) {
                                            selectedTariff = tariff[1];
                                        }

                                //1.1. Населенню (у тому числі яке проживає в житлових будинках, обладнаних кухонними електроплитами):
                                } else if (Calculator.list.heating == '1') {
                                        selectedTariff = tariff[0];
                                }

                                meter.tariffs = [];
                                meter.Unit = 'кВтч';
                                if (angular.isNumber(selectedTariff) && !isNaN(selectedTariff)) {
                                    tariffAmount = selectedTariff;
                                    meter.calcAmount = (new BigNumber(meter._difference)).times(selectedTariff).round(2, BigNumber.ROUND_HALF_CEIL);
                                    meter.tariffs = [
                                      {
                                        tariff: tariffAmount,
                                        special: true,
                                      }
                                    ];
                                } else {
                                        var findTariff = selectedTariff.find(function (val) {
                                            return val.from < meter._difference && meter._difference <= val.to;
                                        });

                                        tariffAmount = findTariff ? findTariff.tariff : tariffAmount;

                                        meter.calcAmount = new BigNumber(0);
                                        var meterNum = meter._difference;
                                        selectedTariff.forEach(function (tariff) {
                                            if (!tariff.large_family) {
                                                if (meterNum - (tariff.to - tariff.from) > 0) {
                                                    tariff.amount = (new BigNumber(tariff.to - tariff.from)).times(tariff.tariff).round(2, BigNumber.ROUND_HALF_CEIL);
                                                    meter.calcAmount = (new BigNumber(tariff.to - tariff.from)).times(tariff.tariff).plus(meter.calcAmount).round(2, BigNumber.ROUND_HALF_CEIL);
                                                    meterNum -= (tariff.to - tariff.from);
                                                    meter.tariffs.push(tariff);
                                                } else {
                                                    if (meterNum > 0) {
                                                        tariff.amount = (new BigNumber(meterNum)).times(tariff.tariff).round(2, BigNumber.ROUND_HALF_CEIL);
                                                        meter.calcAmount = (new BigNumber(meterNum)).times(tariff.tariff).plus(meter.calcAmount).round(2, BigNumber.ROUND_HALF_CEIL);
                                                        meter.tariffs.push(tariff);
                                                    }
                                                    meterNum = 0;
                                                }
                                            }
                                        });
                                }

                                meter.enableTariff = false;
                                meter.calcTariff = meter.tariff = tariffAmount ? tariffAmount : meter.tariff;

                                meter.calcDifference = meter._difference;
                                Calculator.calcDiscount();
                            },
                            calcDiscount: function () {


                                $scope.meter.calcTariff = $scope.meter.calcTariff.toString().replace(/\,/, '.');
                                var totalUnits = 0;
                                var totalSum = 0;
                                var stopEach;
                                Calculator.list.privileges.forEach(function (val, key) {
                                    if (stopEach || !val.Units || !val.Percent) {
                                        return;
                                    }

                                    val.Percent = val.Percent.replace(/\,/, '.');

                                    var units = $scope.meter._difference >= val.Units ?
                                        val.Units : $scope.meter._difference;

                                    totalUnits += parseFloat(val.Units);

                                    if (totalUnits >= $scope.meter._difference) {
                                        totalUnits = $scope.meter._difference;
                                        stopEach = true;
                                    }

                                    if (val.Percent.search(/\d\%/g) !== -1) {
                                        if (
                                            parseFloat(
                                                val.Percent
                                            ) > 100
                                        ) {
                                            val.Percent = '100%';
                                        }

                                        totalSum += parseFloat(
                                            (new BigNumber($scope.meter.calcTariff))
                                            .times(val.Percent.replace(/\%/, ''))
                                            .div(100)
                                            .times(units)
                                        );
                                    } else {
                                        totalSum += parseFloat(
                                            (new BigNumber(parseFloat(val.Percent))).times(units)
                                        );
                                    }

                                });
                                var difference = new BigNumber($scope.meter._difference);
                                $scope.meter.Amount = difference.times($scope.meter.calcTariff).toFixed(2);
                                $scope.meter.calcAmountDiscount = $scope.meter.calcAmount || 0;
                                $scope.meter.Amount = $scope.meter.calcAmountDiscount;
                            },
                            resetCalculate: function(){

                                Calculator.list.location= '1';
                                Calculator.list.house = '1';
                                Calculator.list.stove = '0';
                                Calculator.list.heating = '1';
                                Calculator.list.hostel ='0';
                                Calculator.list.total = '0';
                                Calculator.list.large_families = '0';
                                Calculator.list.selectedMonth = Calculator.getThisMonth();
                                this.calcTariff($scope.meter);
                            },
                            setAmount: function () {
                                $scope.meter.difference = $scope.meter.calcDifference;
                                $scope.meter.Amount = $scope.meter.calcAmountDiscount;
                                $scope.meter.current = +$scope.meter._difference + +$scope.meter.previous;
                                $scope.meter.showCalc = false;

                                $scope.calc($scope.meter);
                            }
                        };
                        var baseCalculatorList = Calculator.list;

                        $scope.calctariffs({calcTariff: Calculator.calcTariff});
                        $scope.Calculator = Calculator;
                    }
                ]
            };
        }
    ])

module.exports = 'directives.calculator';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/calculator/directives/calculator.directive.js
 ** module id = 138
 ** module chunks = 1
 **/